<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import SideCart from "./Partials/SideCart.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { inertia, useForm, page } from "@inertiajs/svelte";
  import Gov2go from "./Partials/Gov2go.svelte";

  import { tick, onMount } from "svelte";

  export let input;

  const form = useForm("reminderForm", {
    dln: input?.dln || "",
    first_name: input?.first_name || "",
    last_name: input?.last_name || "",
    email: input?.email || "",
  });

  let formVisible = true,
    formEl,
    showGov2go;

  async function toggleRemindersForm() {
    formVisible = !formVisible;
    await $form.clearErrors();
    await tick();
    if (formEl) {
      formEl.scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  function handleSubmit() {
    $form.clearErrors();
    let p = $form.post(window.route("renewal.reminders.submit"), {
      preserveScroll: true,
      onSuccess: () => showGov2goModal(),
    });
  }

  function showGov2goModal() {
    showGov2go = true;
  }
</script>

<PageHead>
  <svelte:fragment slot="title">Reminders</svelte:fragment>
  <svelte:fragment slot="tagline">You're almost finished!</svelte:fragment>
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="search"></span>
    <span slot="cart"></span>
    <span slot="reminders"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-12 col-lg-8">
        <Alerts />
        <Alerts {form} />
        <div class="card">
          <div class="card-body">
            {#if formVisible}
              <p>
                Would you like to receive an email reminder instead of a mailed
                reminder when your vehicle's registration is due for renewal
                next year?
              </p>
              <div class="row g-2 gx-5 justify-content-between m-2">
                <div class="col-md-6 d-grid">
                  <button
                    on:click|preventDefault={toggleRemindersForm}
                    class="btn btn-outline-primary text"
                  >
                    Yes, register for email reminders
                  </button>
                </div>
                <hr
                  class="my-3 border-secondary-subtle d-block d-md-none w-50 mx-auto"
                />
                <div class="col-md-6 d-grid mt-0 mt-md-2">
                  <button class="btn btn-success" on:click={showGov2goModal}
                    >No thanks, continue to checkout <i
                      class="bi bi-arrow-right"
                    ></i></button
                  >
                </div>
              </div>
            {:else}
              <p bind:this={formEl}>
                Complete the form below to receive email notices when your
                vehicle is due for renewal.
                <span class="text-muted small d-block"
                  >If you choose to receive renewal notices by email, you will
                  no longer receive a notice by postal mail.</span
                >
              </p>

              <div class="row g-3 mx-md-5">
                <div class="col-md-6">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control"
                      id="first_name"
                      placeholder="John"
                      class:is-invalid={$form.errors["first_name"]}
                      bind:value={$form.first_name}
                    />
                    <label for="first_name" class="form-label">First Name</label
                    >
                    {#if $form.errors["first_name"]}
                      <div class="invalid-feedback">
                        {$form.errors["first_name"]}
                      </div>
                    {/if}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control"
                      id="last_name"
                      placeholder="Smith"
                      class:is-invalid={$form.errors["last_name"]}
                      bind:value={$form.last_name}
                    />
                    <label for="last_name" class="form-label">Last Name</label>
                    {#if $form.errors["last_name"]}
                      <div class="invalid-feedback">
                        {$form.errors["last_name"]}
                      </div>
                    {/if}
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-floating">
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="me@example.com"
                      class:is-invalid={$form.errors["email"]}
                      bind:value={$form.email}
                    />
                    <label for="email" class="form-label">Email Address</label>
                    {#if $form.errors["email"]}
                      <div class="invalid-feedback">
                        {$form.errors["email"]}
                      </div>
                    {/if}
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-floating">
                    <input
                      type="text"
                      class="form-control"
                      id="dln"
                      placeholder="00000000"
                      class:is-invalid={$form.errors["dln"]}
                      bind:value={$form.dln}
                    />
                    <label for="dln" class="form-label"
                      >Driver's License #</label
                    >
                    {#if $form.errors["dln"]}
                      <div class="invalid-feedback">
                        {$form.errors["dln"]}
                      </div>
                    {/if}
                  </div>
                </div>
                <div class="col-12">
                  <div class="row justify-content-between">
                    <div class="col-5 d-grid">
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        id="button-addon2"
                        name="search_type"
                        on:click|preventDefault={toggleRemindersForm}
                        disabled={$form.processing}>Cancel</button
                      >
                    </div>
                    <div class="col-5 d-grid">
                      <button
                        class="btn btn-success"
                        type="submit"
                        id="button-addon2"
                        name="search_type"
                        on:click|preventDefault={handleSubmit}
                        disabled={$form.processing}>Submit</button
                      >
                    </div>
                  </div>
                </div>
              </div>
            {/if}
          </div>
          <div class="card-footer">
            <a
              class="btn btn-secondary my-2 ms-2"
              use:inertia
              href={window.route("renewal.cart")}
              id="button-addon2"><i class="bi bi-arrow-left-short"></i> Back</a
            >
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 mt-lg-0 mt-4">
        <SideCart />
      </div>
    </div>
  </div>
</div>
<Gov2go bind:showGov2go />
